import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import type { NodeSpec } from './NodeSpec';

export const eventOneShotUiNodeSpec: NodeSpec<NodeCfg<'eventOneShot'>> = {
    requiredSockets: [ 'input', 'output' ],
    cfg: () => ({ id: getUID(), kind: 'eventOneShot', disabled: false }),
    controls: () => ({}),
    inputs: () => ({
        input: { socket: 'event', label: 'Input' },
        reset: { socket: 'event', label: 'Reset' },
    }),
    kindLabel: 'Event One Shot',
    nodeCategory: 'events',
    outputs: () => ({ output: { socket: 'event', label: 'Output' } }),
    validator: () => true,
};
